import React, {Component} from 'react';
import renderHTML from 'react-render-html';

import Image from './article/image';
import MapListTitle from './article/maplisttitle';
import Content from '../../containers/parts/content';
import Meta from './article/meta';
import PostFooter from '../../containers/parts/post-footer';

export default class MapList extends Component {
	getClasses() {
		return this.props.isSingle ? 'single' : 'card archive col-6';
	}

	getFeaturedImageSrc() {
		if (this.props.post.featured_image_url) {
			return this.props.isSingle ? this.props.post.featured_image_url.large : this.props.post.featured_image_url.full;
		} else {
			return '';
		}
	}

	getCategories(cat_ids) {
		if ('undefined' !== typeof cat_ids) {
			return cat_ids.map(cat_id => {
				return RT_API['categories'].filter(cat => {
					return cat.term_id === cat_id
				})[0];
			});
		}
	}

	getContent(post, isSingle) {
		return (isSingle) ? post.content.rendered : post.excerpt.rendered;
	}

	render() {
		const post = this.props.post;
		let imageUrl = null;
		let imageWidth = null; 
		let imageHeight = null;
		let titleHeader = null;
		//console.log(post);
		if (post.featured_media !== 0 ){
			imageUrl = post.better_featured_image.source_url;
			imageWidth = post.better_featured_image.media_details.width; 
			imageHeight = post.better_featured_image.media_details.height;
			
		} 
		if ( post.Marker ){
			titleHeader = post.Marker.properties.description;
		}
			
		return (
			titleHeader && <article className="card archive col-6">
				<div className="card-block">
					<Image src={imageUrl} width={imageWidth} height={imageHeight} />
					<div className="card-text">
						<MapListTitle content={titleHeader} />
						{ renderHTML( post.content.rendered ) }
					</div>
				</div>
			</article>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/main/map_list.js